<script setup>
import { reactive, computed, defineProps, ref } from 'vue'
import YouTube from 'vue3-youtube'

const props = defineProps(['iframeSrc'])

const youtubePlayer = ref(null);

const state = reactive({ showThumbnail: false })

const hasYoutubeVideoSrc = computed(() => {
    return ! _.isEmpty(props.iframeSrc)
})
</script>

<template>
    <div class="vue-bg-video-wrapper">
        <template v-if="hasYoutubeVideoSrc">
            <div class="video-wrapper">
                <YouTube :src="iframeSrc" ref="youtubePlayer" class="iframe-wrapper" width="100%" height="100%"></YouTube>
            </div>
        </template>
    </div>
</template>

<style scoped>
.thumbnail-image {
    width: 100%;
    height: auto;
    cursor: pointer;
}
.play-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    border-radius: 50%;
    padding: 10px;
    cursor: pointer;
    font-size: 16px;
}
.video-wrapper {
    position: relative;
}
.iframe-wrapper {
    width: 100%;
    height: 100%;
}
</style>